module.exports = __webpack_public_path__ + "img/message_icon-fill.3e847304.svg";